module.exports = __webpack_public_path__ + "static/actions-based-on-responses-92aa9a9fcb75902e06111db20cc173ad.svg";